import { env } from "../config/env";
import { createClient } from "./http";

const api = createClient(env.ORDER_BASE_URL || env.AUTH_BASE_URL);

function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

export const driverFinancialControlsService = {
  list(params = {}) {
    return api.get("/api/admin/driver-financial-controls/drivers", {
      params: cleanParams(params),
    });
  },

  get(driverId) {
    return api.get(`/api/admin/driver-financial-controls/drivers/${encodeURIComponent(String(driverId || ""))}`);
  },

  getEvents(driverId, params = {}) {
    return api.get(`/api/admin/driver-financial-controls/drivers/${encodeURIComponent(String(driverId || ""))}/events`, {
      params: cleanParams(params),
    });
  },

  update(driverId, payload) {
    return api.patch(`/api/admin/driver-financial-controls/drivers/${encodeURIComponent(String(driverId || ""))}`, payload);
  },

  extendDeadline(driverId, payload) {
    return api.post(`/api/admin/driver-financial-controls/drivers/${encodeURIComponent(String(driverId || ""))}/extend-deadline`, payload);
  },

  clearOverride(driverId, payload = {}) {
    return api.del(`/api/admin/driver-financial-controls/drivers/${encodeURIComponent(String(driverId || ""))}/override`, {
      body: payload,
    });
  },
};
